import { Category, CategoryId, NumberType, SectionKey, TypeDescriptor } from '../types/angelNumber';

export const categories: Category[] = [
  { id: 'angel', label: 'Angel Numbers', icon: '✨', blurb: 'The classic repeating sequences.' },
  { id: 'portal', label: 'Portal', icon: '🚪', blurb: 'Symbolic doorways and moments of heightened intention.' },
  { id: 'mirror', label: 'Mirror', icon: '🪞', blurb: 'Patterns that read the same both ways.' },
  { id: 'time', label: 'Mirror Hours', icon: '⏰', blurb: 'Patterns you notice on a clock.' },
  { id: 'master', label: 'Master', icon: '🔢', blurb: 'Single themes turned up in volume.' },
  { id: 'sequence', label: 'Sequences', icon: '➡️', blurb: 'Step-by-step patterns of progress.' },
  { id: 'guidance', label: 'Guidance', icon: '🕊️', blurb: 'Short, gentle symbolic messages.' },
  { id: 'new_beginnings', label: 'New Beginnings', icon: '🌱', blurb: 'Fresh starts and open doors.' },
  { id: 'love', label: 'Love', icon: '❤️', blurb: 'Connection, honesty and the heart.' },
  { id: 'relationships', label: 'Relationships', icon: '🤝', blurb: 'Partnership, family and how you relate.' },
  { id: 'abundance', label: 'Abundance', icon: '💰', blurb: 'Flow, receiving and enough-ness.' },
  { id: 'money', label: 'Money', icon: '🪙', blurb: 'A calmer relationship with resources.' },
  { id: 'career', label: 'Career', icon: '💼', blurb: 'Work, ambition and momentum.' },
  { id: 'protection', label: 'Protection', icon: '🛡', blurb: 'Steadiness, safety and support.' },
  { id: 'manifestation', label: 'Manifestation', icon: '✦', blurb: 'Intention, focus and creation.' },
  { id: 'transformation', label: 'Transformation', icon: '🔥', blurb: 'Change, release and becoming.' },
  { id: 'spiritual_growth', label: 'Spiritual Growth', icon: '🌙', blurb: 'Inner listening and quiet expansion.' },
  { id: 'inner_peace', label: 'Inner Peace', icon: '🧘', blurb: 'Calm, balance and rest.' },
  { id: 'intuition', label: 'Intuition', icon: '🔮', blurb: 'The knowing underneath the noise.' },
  { id: 'awakening', label: 'Awakening', icon: '👁', blurb: 'Noticing more than you did before.' },
  { id: 'balance', label: 'Balance', icon: '⚖️', blurb: 'Equilibrium between competing pulls.' },
  { id: 'creativity', label: 'Creativity', icon: '🎨', blurb: 'Expression and making things.' },
  { id: 'completion', label: 'Completion', icon: '🌗', blurb: 'Endings, closure and release.' },
  { id: 'reflection', label: 'Reflection', icon: '💫', blurb: 'Pausing to look honestly.' },
];

export const categoryMap: Record<CategoryId, Category> = categories.reduce(
  (acc, c) => {
    acc[c.id] = c;
    return acc;
  },
  {} as Record<CategoryId, Category>,
);

export const numberTypes: TypeDescriptor[] = [
  { id: 'angel_number', label: 'Angel number', plural: 'Angel Numbers', icon: '✨' },
  { id: 'portal_number', label: 'Portal number', plural: 'Portal Numbers', icon: '🚪' },
  { id: 'mirror_number', label: 'Mirror number', plural: 'Mirror Numbers', icon: '🪞' },
  { id: 'mirror_hour', label: 'Mirror hour', plural: 'Mirror Hours', icon: '⏰' },
  { id: 'master_number', label: 'Master number', plural: 'Master Numbers', icon: '🔢' },
  { id: 'sequential_number', label: 'Sequential number', plural: 'Sequential Numbers', icon: '➡️' },
  { id: 'special_sequence', label: 'Special sequence', plural: 'Special Sequences', icon: '💫' },
  { id: 'portal_date', label: 'Portal date', plural: 'Portal Dates', icon: '📅' },
];

export const typeMap: Record<NumberType, TypeDescriptor> = numberTypes.reduce(
  (acc, t) => {
    acc[t.id] = t;
    return acc;
  },
  {} as Record<NumberType, TypeDescriptor>,
);

/** Display order for content sections. Empty sections are skipped by the UI. */
export const sectionOrder: { key: SectionKey; icon: string }[] = [
  { key: 'coreMeaning', icon: '🌌' },
  { key: 'loveMeaning', icon: '❤️' },
  { key: 'careerMeaning', icon: '💼' },
  { key: 'spiritualMeaning', icon: '🌙' },
  { key: 'portalMeaning', icon: '🚪' },
  { key: 'twinFlameMeaning', icon: '🔥' },
  { key: 'numerologyMeaning', icon: '🔢' },
  { key: 'historicalSymbolism', icon: '📜' },
];
